const routes = [
  {
    index: true,
    label: 'Vijay Chaudhari',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  // {
  //   label: 'Projects',
  //   path: '/projects',
  // },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
